module.exports = __webpack_public_path__ + "static/footer-cat.8c24b96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Help/footer-cat.png
// module id = 135
// module chunks = 1135276415346 35783957827783